import script from "./RecursiveFormFields.vue?vue&type=script&setup=true&lang=js"
export * from "./RecursiveFormFields.vue?vue&type=script&setup=true&lang=js"

import "./RecursiveFormFields.vue?vue&type=style&index=0&id=60210e5e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60210e5e"]])

export default __exports__